import getCompareDate from '../../../utils/date/getCompareDate';

export const COMPARE_TEXT_MAP = {
    daily: '어제',
    weekly: '지난 주',
    monthly: '지난 달',
};
const COMPARE_BAR_NAME_MAP = {
    daily: { prevName: '어제', currName: '오늘' },
    weekly: { prevName: '지난 주', currName: '이번 주' },
    monthly: { prevName: '지난 달', currName: '이번 달' },
};

export const getReportContent = (variant, dateType) => {
    const title = variant === 'amount' ? `매출이 ${COMPARE_TEXT_MAP[dateType]} 대비` : `매출 건수가 ${COMPARE_TEXT_MAP[dateType]} 대비`;
    const barName = COMPARE_BAR_NAME_MAP[dateType];
    const compareDate = getCompareDate(dateType);

    return { title, barName, compareDate };
};
